/// <amd-module name="Wit/BacklogsHub/Common/BacklogContracts" />

import { WorkItemTypeReference } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { ITeam } from "Wit/Common/BacklogContentService/BacklogContentDataProviderTypes";

export interface IProductBacklogTabContext {
    level: string;
    workItemTypes: WorkItemTypeReference[];
    team: ITeam;
    foregroundInstance: boolean;
}
